<template>
  <q-page class="bg-black q-pb-xl">
  <!--
  <q-input 
    v-model="lookedForDrink" standout="bg-dark-grey" rounded bg-color="dark-grey" color="dark-grey-clear" class="q-pa-md" label-slot>
      <template v-slot:label>

        <p class="text-dark-grey-clear">Rechercher une boisson</p>
    </template>
    <template v-slot:append>
      <q-icon name="search" size="2em" color="dark-grey-clear"/>
    </template>
  </q-input>
  -->
    <div v-for="(cat, index) in categories" :key="cat.id" class="q-px-md">
      <category-mobile :category="cat" :color="colors[index]"/>
      <template v-for="drink in cat.drinks">
        <router-link :to="{name: 'mobileDrinksDetail', params: {idSeance: idSeance, idDrink: drink.id}}">
          <drink-mobile :drink="drink" :key="drink.id"/>
        </router-link>
      </template>
    </div>
  </q-page>
</template>
  
<script>
  
import ReconnectingEventSource from "reconnecting-eventsource";
import { getAllDrinksAnonymousByCatBySeance, getPriceHistoriesAnonymousBySeance } from '~/services/drinks';
import { getAnonymousSeanceById } from '~/services/seances';
import { baseUrl, base_url_seances } from '~/variables';
import CategoryMobile from '../components/CategoryMobile.vue';
import DrinkMobile from '../components/DrinkMobile.vue';

export default {
  name: "mobileDrinks",
  components: {
    CategoryMobile,
    DrinkMobile
  },
  data() {
    return {
      categories: [],
      colors: ['text-green-4', 'text-pink-4', 'text-light-blue-4', 'text-yellow-4', 'text-orange-4', 'text-red-4'],
      idSeance: null,
      showKrackDialog: false,
      startKrack: true,
      timesCategories: [],
      series: [],
      seance:{},
      es: null,
      lookedForDrink: ""
    };
  },  
  async created() {
    this.idSeance = this.$route.params.idSeance;
    let response = await getAnonymousSeanceById(this.idSeance);
    if (response.status == 200) {
      this.seance = response.data;
    }
    response = await getAllDrinksAnonymousByCatBySeance(this.idSeance);
    if (response.status === 200) {
      this.categories = response.data.map(ctg => { 
        ctg.drinks = ctg.drinks.map(e => {
          return {...e, difference: 0.00} 
        })
        return ctg
      });
    } 
    /*
    response = await getPriceHistoriesAnonymousBySeance(this.idSeance);
    if (response.status == 200) {
      // Tri pour récupérer la boisson qui a été créée en première
      this.drinks.sort(function(a, b) {
        return a.id - b.id;
      });
      this.drinks.map(e => {
        this.series.push(
          {
            name: e.name,
            data: response.data.filter(e1 => e.id == e1.drink_id).map(e2 => [e2.time, e2.price.toFixed(2)])
          }
        )
      })
    }*/
  },
  mounted() {
    this.setupStream();
  },
  destroyed () {
    this.es.close()
  },
  methods: {
    setupStream() {
      // Not a real URL, just using for demo purposes
      this.es = new ReconnectingEventSource(`${baseUrl}${base_url_seances}/${this.idSeance}/events/`);

      this.es.addEventListener('command', event => {
        let data = JSON.parse(event.data);
        const prices = data.consommation_set.map(e => e.price * e.quantite)
        let price = prices.reduce((accumulator, currentValue) => accumulator + currentValue);
        price = Number.parseFloat(price).toFixed(2);
        this.$q.notify({
          color: 'green-4',
          textColor: 'white',
          icon: 'fas fa-check-circle',
          message: `Nouvelle commande: ${price} € `,
          position: 'top-right',
        });
      }, false);
      this.es.addEventListener('update', event => {
        let data = JSON.parse(event.data);
        data.map( e => {
          // Récupération de l'index de la boisson qu'on va traiter
          var catI = 0;
          var drinkI = 0;
          var found = false
          for (const cat of this.categories) {
            drinkI=0;
            for (const drink of cat.drinks) {
              if (drink.id === e.drink.id) {
                found = true;
                break;
              }
              drinkI+=1;
            }
            if (found) {
              break
            }
            catI+=1;
          }
          // Récupération de l'ancien prix
          const old_price = this.categories[catI].drinks[drinkI].current_price;
          //Calcul de la différence en pourcentage
          const difference = (((e.price / old_price) * 100) - 100)
          // Forcage de la réactivité
          this.$set(this.categories[catI].drinks, drinkI , {...e.drink, difference})
          /*
          const index2 = this.series.findIndex(e1 => e1.name === e.drink.name);
          let serie = this.series[index2].data;
          let tempSeries = [...this.series];
          tempSeries[index2].data.push([e.time, e.price])
          // On enlève les éléments dont la date est plus grande que 30 minutes
          tempSeries[index2].data = tempSeries[index2].data.filter(el => new Date(el[0]) > new Date(Date.now() - 1000 * 60 * 40))
          this.series = [...tempSeries];*/
        });
      }, false);
      this.es.addEventListener('krach_start', event => {
        this.startKrack = true;
        this.toggleKrackDialog();
        setTimeout(() => this.toggleKrackDialog(), 2500)
      }, false);
      this.es.addEventListener('krach_stop', event => {
        this.startKrack = false;
        this.toggleKrackDialog();
        setTimeout(() => this.toggleKrackDialog(), 2500)
      }, false);
    },
    toggleKrackDialog() {
      this.showKrackDialog = !this.showKrackDialog;
    }
  },
}
</script>
<style lang="scss" scoped>
a {
  text-decoration: none;
}
.q-layout{
  font-family: 'Montserrat';
}
.q-header, .footer-toolbar{
  border-style: solid;
  border-width: 2px;
  border-image: linear-gradient(to left, rgba(0, 0, 0, 1) 1%, #7B7B7B 50%, rgba(0, 0, 0, 1) 100%) 
                100% 0 100% 0/2px 0 2px 0 stretch;
}
</style>